import { render, staticRenderFns } from "./AuxiliaryAccountingDetail.vue?vue&type=template&id=125d04fb&scoped=true"
import script from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"
export * from "./AuxiliaryAccountingDetail.vue?vue&type=script&lang=js"
import style0 from "./AuxiliaryAccountingDetail.vue?vue&type=style&index=0&id=125d04fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d04fb",
  null
  
)

export default component.exports